export default __webpack_public_path__ + "static/media/blackboard-landscape.8f0583fc.jpg";